import React from 'react';

import SidebarButton from './SidebarButton';

import useAddQueryParam from '../../../hooks/useAddQueryParams';
import { useUiStore } from '../../../store';

const isActive = (section, currentQueryParam) => {
  let active = section.title === currentQueryParam;

  if (!active && section.activeOn && Array.isArray(section.activeOn)) {
    active = section.activeOn.includes(currentQueryParam);
  } else if (!active && section.activeOn) {
    active = section.activeOn === currentQueryParam;
  }

  return active;
};

export default function Sidebar({ sections, isEdit, url }) {
  const { addQueryParam, currentQueryParam } = useAddQueryParam('tab', url);

  const loanHeaderHeight = useUiStore((state) => state.loanHeaderHeight);

  return (
    <>
      {/* <div className="w-full md:w-36 mb-0 hidden md:block" /> */}
      <div className="w-full md:w-36 mb-0">
        <div>
          <div
            className={`md:py-8 md:h-[calc(100vh-${loanHeaderHeight}px-64px)] overflow-x-auto`}
          >
            {/* Links */}
            <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto  md:space-y-3 w-full relative">
              <div>
                <div className="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase mb-3 md:sr-only opacity-0">
                  Menu
                </div>
                <ul className="flex flex-nowrap gap-2 my-4 overflow-auto md:overflow-hidden md:block">
                  {sections.map((section) => (
                    <SidebarButton
                      key={section.title}
                      section={section}
                      isActive={isActive(section, currentQueryParam)}
                      onClick={() => {
                        section.onClick?.();
                        if (isEdit) {
                          addQueryParam('tab', section.title);
                        }
                      }}
                    />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
